export const WHODUNIT_2026_PASSWORD = 'ILOVEMYGE';

export const WHODUNIT_2026_FACTS = {
  'proposal-holiday': {
    slot: 1,
    kind: 'genuine',
    answer: 'pig',
    take: 2,
    trueText: 'Christmas',
    puzzleText: "New Year's Eve",
    clue: 'A pink farm animal — take the second letter.',
  },
  'wedding-date': {
    slot: 2,
    kind: 'genuine',
    answer: 'lid',
    take: 1,
    trueText: 'Sunday, May 21, 2023',
    puzzleText: 'Sunday, May 28, 2023',
    clue: 'A cover on top of a container — take the first letter.',
  },
  'relationship-date': {
    slot: 3,
    kind: 'genuine',
    answer: 'box',
    take: 2,
    trueText: '26th January 2021',
    puzzleText: '26th February 2021',
    clue: 'A container with four sides — take the second letter.',
  },
  'ring-date': {
    slot: 4,
    kind: 'genuine',
    answer: 'van',
    take: 1,
    trueText: '4th March 2023',
    puzzleText: '11th March 2023',
    clue: 'A vehicle for carrying goods — take the first letter.',
  },
  venue: {
    slot: 5,
    kind: 'genuine',
    answer: 'bed',
    take: 2,
    trueText: 'The British Academy',
    puzzleText: 'The British Library',
    clue: 'Where you sleep — take the second letter.',
  },
  address: {
    slot: 6,
    kind: 'genuine',
    answer: 'map',
    take: 1,
    trueText: "10-11 Carlton House Terrace, St. James's, London",
    puzzleText: "11-12 Carlton House Terrace, St. James's, London",
    clue: 'A drawing that helps you find places — take the first letter.',
  },
  'arrival-time': {
    slot: 7,
    kind: 'genuine',
    answer: 'sky',
    take: 3,
    trueText: '2:30 p.m.',
    puzzleText: '2:45 p.m.',
    clue: 'What you see above the clouds — take the third letter.',
  },
  'cake-time': {
    slot: 8,
    kind: 'genuine',
    answer: 'log',
    take: 3,
    trueText: '8:30 p.m.',
    puzzleText: '8:00 p.m.',
    clue: 'A cut piece of a tree trunk — take the third letter.',
  },
  'menu-seed': {
    slot: 9,
    kind: 'genuine',
    answer: 'ten',
    take: 2,
    trueText: 'pine seed salad',
    puzzleText: 'pumpkin seed salad',
    clue: 'The number after nine — take the second letter.',
  },
  'decoy-proposal-date': {
    slot: 1,
    kind: 'decoy',
    answer: 'peg',
    take: 2,
    trueText: '23rd December 2022',
    puzzleText: '23rd December 2022',
    clue: 'A small pin used to fasten things — take the second letter.',
  },
  'decoy-dating-app': {
    slot: 2,
    kind: 'decoy',
    answer: 'kid',
    take: 1,
    trueText: 'I met her on a dating app',
    puzzleText: 'I met her on a dating app',
    clue: 'A young goat — take the first letter.',
  },
  'decoy-left-hand': {
    slot: 4,
    kind: 'decoy',
    answer: 'can',
    take: 1,
    trueText: 'left hand',
    puzzleText: 'left hand',
    clue: 'Something cylindrical that holds food — take the first letter.',
  },
  'decoy-ceremony-time': {
    slot: 5,
    kind: 'decoy',
    answer: 'bad',
    take: 2,
    trueText: '3:00 p.m.',
    puzzleText: '3:00 p.m.',
    clue: 'The opposite of good — take the second letter.',
  },
  'decoy-dress-code': {
    slot: 8,
    kind: 'decoy',
    answer: 'lot',
    take: 3,
    trueText: 'Formal (Bring your dancing shoes!)',
    puzzleText: 'Formal (Bring your dancing shoes!)',
    clue: 'A large amount — take the third letter.',
  },
  'decoy-dessert': {
    slot: 9,
    kind: 'decoy',
    answer: 'tin',
    take: 2,
    trueText: 'Dorset Strawberry millefeuille',
    puzzleText: 'Dorset Strawberry millefeuille',
    clue: 'A silvery metal — take the second letter.',
  },
};

export const WHODUNIT_2026_GENUINE_FACT_IDS = [
  'proposal-holiday',
  'wedding-date',
  'relationship-date',
  'ring-date',
  'venue',
  'address',
  'arrival-time',
  'cake-time',
  'menu-seed',
];

export const getWhodunit2026Fact = (factId) => {
  const fact = WHODUNIT_2026_FACTS[factId];
  if (!fact) {
    throw new Error(`Unknown Whodunit 2026 fact: ${factId}`);
  }
  return fact;
};

export const getWhodunit2026FactLetter = (factOrId) => {
  const fact = typeof factOrId === 'string' ? getWhodunit2026Fact(factOrId) : factOrId;
  const letter = fact?.answer?.[fact.take - 1];

  if (!letter || !/^[a-z]$/i.test(letter)) {
    throw new Error('Invalid Whodunit 2026 clue answer');
  }

  return letter.toUpperCase();
};

export const validateWhodunit2026Catalog = () => {
  Object.entries(WHODUNIT_2026_FACTS).forEach(([factId, fact]) => {
    if (
      !Number.isInteger(fact.slot)
      || fact.slot < 1
      || fact.slot > WHODUNIT_2026_PASSWORD.length
      || !['genuine', 'decoy'].includes(fact.kind)
    ) {
      throw new Error(`Invalid Whodunit 2026 fact metadata: ${factId}`);
    }
    getWhodunit2026FactLetter(fact);
  });

  if (WHODUNIT_2026_GENUINE_FACT_IDS.length !== WHODUNIT_2026_PASSWORD.length) {
    throw new Error('Whodunit 2026 genuine fact count does not match password length');
  }

  const catalogGenuineFactIds = Object.entries(WHODUNIT_2026_FACTS)
    .filter(([, fact]) => fact.kind === 'genuine')
    .sort(([, left], [, right]) => left.slot - right.slot)
    .map(([factId]) => factId);
  if (catalogGenuineFactIds.join(',') !== WHODUNIT_2026_GENUINE_FACT_IDS.join(',')) {
    throw new Error('Whodunit 2026 must have exactly one registered genuine fact per slot');
  }

  const genuineSlots = WHODUNIT_2026_GENUINE_FACT_IDS.map((factId) => {
    const fact = getWhodunit2026Fact(factId);
    if (fact.kind !== 'genuine') {
      throw new Error(`Whodunit 2026 genuine fact is not marked genuine: ${factId}`);
    }
    return fact.slot;
  });

  const expectedSlots = Array.from(
    { length: WHODUNIT_2026_PASSWORD.length },
    (_, index) => index + 1,
  );
  if (genuineSlots.join(',') !== expectedSlots.join(',')) {
    throw new Error('Whodunit 2026 genuine facts must occupy slots 1 through 9 in order');
  }

  const derivedPassword = WHODUNIT_2026_GENUINE_FACT_IDS
    .map(getWhodunit2026FactLetter)
    .join('');
  if (derivedPassword !== WHODUNIT_2026_PASSWORD) {
    throw new Error('Whodunit 2026 clues do not match the canonical password');
  }

  return true;
};

validateWhodunit2026Catalog();
